<template>
  <el-row :gutter="24" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people">
          <img src="@/assets/laji.png" alt style="width: 36px; height: 48px" />    
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            垃圾减量
          </div>
          <count-to :start-val="0" :end-val="panelData.totalWeightNums" :duration="2600" class="card-panel-num" />吨
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-money">
          <img src="@/assets/tan.png" alt style="width: 40px; height: 32px" />    
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            累计减碳
          </div>
          <count-to :start-val="0" :end-val="panelData.reductionCarbon" :duration="3200" class="card-panel-num" />吨
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping">
          <img src="@/assets/che.png" alt style="width: 40px; height: 34px" />    
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            相当于少开
          </div>
          <count-to :start-val="0" :end-val="panelData.kmCar" :duration="3600" class="card-panel-num" />公里车
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/dian.png" alt style="width: 30px; height: 46px" />    
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            相当于节约
          </div>
          <count-to :start-val="0" :end-val="panelData.kwElectricity" :duration="3000" class="card-panel-num" />度电
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  components: {
    CountTo
  },
  props: {
    panelData: {
      type: Object,
    },
  },
  data(){
    return {
      img1: require('@/assets/icon/laji.svg')
    }
  },
  mounted() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;
  padding-bottom: 20px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: transparent;
    border: 2px solid #195E9E; /* 使用主色作为边框颜色 */
    box-shadow: 0 4px 8px 0 rgba(5, 946, 214, 0.5);
    border-radius: 8px; /* 可选，为边框添加圆角 */

    &:hover {
      box-shadow: 0 8px 16px 0 rgba(5, 946, 214, 0.6); /* 鼠标悬浮时加深阴影 */
      .card-panel-icon-wrapper {
        color: #fff;
      }
      // .icon-people {
      //   background: #36a3f7;
      // }

      // .icon-message {
      //   background: #36a3f7;
      // }

      // .icon-money {
      //   background: #36a3f7;
      // }

      // .icon-shopping {
      //   background: #36a3f7;
      // }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #FF7B15;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      i {
          font-size: 48px;
      }
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      color:#E1E6E6;

      .card-panel-text {
        line-height: 18px;
        color:#E1E6E6;
        font-size: 14px;
        margin-bottom: 16px;
      }

      .card-panel-num {
        font-size: 20px;
        color:darkgoldenrod;
        
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
